/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  Grid,
  Box,
  Stack,
  Toolbar,
  Divider,
} from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import Marquee from 'react-fast-marquee';

import {
  displayFlex,
  fontsize10,
  poppins400,
  fontsize14,
  poppins300,
  staticCard,
  fontsize12,
} from 'theme/common.style';
import { ReactComponent as Home } from 'assets/icons/home-2.svg';
import { ReactComponent as Show } from 'assets/icons/Show.svg';

import { ReactComponent as RHome } from 'assets/icons/Rhome.svg';
import { ToggleOn } from 'component/OwnerCard/OwnerCard';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { GET_PROPERTIES_ACTIVITY } from 'constant/app.config';
import { getApiCall } from 'api/apiService';
import { IconMap } from 'antd/es/result';
import { property } from 'lodash';

const ToggleOff = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="41.5391"
        y="24.3711"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        transform="rotate(-180 41.5391 24.3711)"
        fill="url(#paint0_linear_15918_145940)"
      />
      <ellipse
        cx="11.9067"
        cy="12.1868"
        rx="8.52103"
        ry="8.86199"
        transform="rotate(-180 11.9067 12.1868)"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15918_145940"
          x1="53.8123"
          y1="22.7095"
          x2="59.336"
          y2="52.7206"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const IOSSwitch = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="41.5391"
        y="24.3705"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        transform="rotate(-180 41.5391 24.3705)"
        fill="url(#paint0_linear_4370_15242)"
      />
      <ellipse
        cx="11.9067"
        cy="12.1854"
        rx="8.52103"
        ry="8.86199"
        transform="rotate(-180 11.9067 12.1854)"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4370_15242"
          x1="53.8123"
          y1="22.7089"
          x2="59.336"
          y2="52.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
var userDetail = localStorage.getItem('primaryUser');
function PropertySliderContent(props) {
  const [buyerToOwner, setBuyerToOwner] = React.useState(false);
  const [ownerToBuyer, setOwnerToBuyer] = React.useState(true);
  const [primaryUserValue, setPrimaryUserValue] = React.useState(() => {
    return JSON.parse(localStorage.getItem(userDetail) || userDetail);
  });

  const history = useHistory();

  const data1 = localStorage.getItem('userDetail');
  const userDetails = JSON.parse(data1);
  const dataType = userDetails?.userType;
  const currentPage = window.location.pathname;

  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));

  const [isPaused, setIsPaused] = React.useState(false);

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  function formatPrice(price) {
    if (price && price !== '0') {
      return `$${Number(price).toLocaleString()}`;
    }
    return '';
  }

  const [properties, setProperties] = useState([]);

  const getpropertiesactivity = async () => {
    getApiCall(GET_PROPERTIES_ACTIVITY).then((res) => {
      if (res?.data?.status == 1) {
        setProperties(res?.data?.properties || []);
      } else {
        console.log('Failed to fetch properties activity');
      }
    });
  };

  useEffect(() => {
    getpropertiesactivity();
  }, []);

  const iconMap = {
    'Just Listed': <Home style={{ color: '#10D35E', marginRight: '3px' }} />, // Green for Property Listed
    Sold: <RHome style={{ color: '#F93939', marginRight: '3px' }} />, // Red for Sold
    'Offer Received': <Show style={{ color: '#2FCDFF', marginRight: '3px' }} />, // Blue for Offer Received
  };

  const statusColors = {
    'Just Listed': '#10D35E',
    Sold: '#F93939',
    'Offer Received': '#2FCDFF',
  };

  // const handleClick = (propertyId, isLinkedAgent) => {
  //   const cleanPropertyId = propertyId?.toString().replace(/\/+/g, ''); // Prevent unwanted slashes
  //   const url = isLinkedAgent === "1"
  //     ? `/dashboard/view-dashboard/${cleanPropertyId}`
  //     : `/share/${cleanPropertyId}`;

  //   history.push(url);
  // };

  const handleClick = (propertyId, isLinkedAgent) => {
    const cleanPropertyId = propertyId?.toString().replace(/\/+/g, '');
    const url = `/dashboard/view-dashboard/${cleanPropertyId}`;
    history.push(url);
  };

  return (
    <>
      {currentPage.includes('/People') ||
      currentPage.includes('/dashboard') ||
      currentPage.includes('/VendorIndividualDashboard') ||
      currentPage.includes('/VendorInactiveIndividual') ||
      currentPage.includes('/insights') ||
      currentPage.includes('/pipeline') ||
      currentPage.includes('/ProfileSetting') ||
      currentPage.includes('/message') ||
      currentPage.includes('/helpcentre') ||
      currentPage.includes('/invite') ||
      currentPage.includes('/tasks') ||
      currentPage.includes('landingpage') ||
      currentPage.includes('Savedsearch') ||
      currentPage.includes('/notification') ? (
        <div
          style={{
            // backgroundColor: dataType?.length === 1 ? "#345B83" ? dataType?.length === 2 && dataType.find((item) => item?.userType === "Buyer") ? "#DEF3FF" :"#E3D3FD",
            // dataType?.length === 1 && dataType[0].userType !== "Buyer"
            //   ? "#345B83"
            //   : "#DEF3FF",
            backgroundColor:
              // dataType?.length === 1 && primaryUserTypeValue === "Agent"
              // ? "#345B83"
              // : dataType?.length === 2 && primaryUserTypeValue === "Buyer"
              // ? "#DEF3FF"
              // : dataType?.length === 2 && primaryUserTypeValue === "Vendor"
              // ? "#E3D3FD"
              // : /* Default color */ "",
              // dataType?.length === 1 && primaryUserTypeValue === "Agent"
              //   ? "#345B83"
              //   : dataType?.length === 2 && primaryUserTypeValue === "Buyer"
              //   ? "#DEF3FF"
              //   : "#E3D3FD",
              properties.length > 0 && primaryUserValue === 'Agent'
                ? '#345B83'
                : dataType?.length === 2 && primaryUserTypeValue === 'Buyer'
                ? '#DEF3FF'
                : dataType?.length === 2 && primaryUserTypeValue === 'Vendor'
                ? '#E3D3FD'
                : '#FBFBFB', // Default color fallback
            height: primaryUserTypeValue === 'Agent' ? '50px' : '0px',
            paddingTop: primaryUserTypeValue === 'Agent' ? '10px' : '0px',
            paddingBottom: primaryUserTypeValue === 'Agent' ? '10px' : '0px',
          }}
        >
          {dataType?.length === 1 && primaryUserTypeValue === 'Agent' ? (
            <div style={{ cursor: 'pointer', height: '30px' }}>
              <Marquee
                autoFill={true}
                pauseOnHover={!isPaused}
                gradient={false}
                speed={50}
              >
                {properties.map((property, index) => (
                  <Typography
                    key={index}
                    sx={[
                      staticCard,
                      {
                        backgroundColor: '#ffff',
                        cursor: 'pointer',
                      },
                    ]}
                    whiteSpace={'nowrap'}
                    onClick={(e) => {
                      if (property.isLinkedAgent === '1') {
                        handleClick(
                          property.propertyId,
                          property.isLinkedAgent
                        ); // only this redirects
                      } else {
                        history.push({
                          pathname: `/share/${property?.propertyId}`,
                        });
                      }
                    }}
                  >
                    {iconMap[property.status] ?? (
                      <Home style={{ marginRight: '3px' }} />
                    )}
                    <span
                      style={{
                        color: statusColors[property.status] || '#000',
                        marginLeft: '-3px',
                      }}
                    >
                      {property.status}
                    </span>{' '}
                    - {property.address}{' '}
                    {property.price && property.price !== '0'
                      ? `(${formatPrice(property.price)})`
                      : ''}
                  </Typography>
                ))}
              </Marquee>
            </div>
          ) : (
            <div>
              {dataType?.length === 2 && (
                <Grid
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {/* Buyer/Owner Mode Active (Center) */}
                  <Typography
                    sx={{
                      color: 'rgba(0, 0, 0, 1)',
                      fontSize: '16px',
                      fontWeight: 300,
                      fontFamily: 'poppins',
                      textAlign: 'center',
                      marginLeft: '80px',
                      flex: 1,
                    }}
                  >
                    {primaryUserTypeValue === 'Buyer' ? 'Buyer' : 'Owner'} Mode
                    Active
                  </Typography>

                  {/* Buyer and Owner toggle (End) */}
                  <Stack
                    justifyContent={'space-around'}
                    direction={'row'}
                    alignItems={'center'}
                    sx={{ marginRight: '30px' }}
                    gap={1}
                  >
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                        // color: "#112347",
                        color:
                          primaryUserTypeValue === 'Buyer'
                            ? '#112347'
                            : '#9C9C9C',
                      }}
                    >
                      Buyer
                    </Typography>
                    {dataType?.length === 2 && (
                      <>
                        {primaryUserTypeValue === 'Buyer' ? (
                          <Typography
                            onClick={() => {
                              setPrimaryUserValue('Vendor');
                              window.location.reload();
                            }}
                            sx={{ cursor: 'pointer' }}
                          >
                            <ToggleOff />
                          </Typography>
                        ) : (
                          <Typography
                            onClick={() => {
                              setPrimaryUserValue('Buyer');
                              window.location.reload();
                            }}
                            sx={{ cursor: 'pointer' }}
                          >
                            <ToggleOn />
                          </Typography>
                        )}
                      </>
                    )}

                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                        // color: "#112347",
                        color:
                          primaryUserTypeValue === 'Vendor'
                            ? '#112347'
                            : '#9C9C9C',
                      }}
                    >
                      Owner
                    </Typography>
                  </Stack>
                </Grid>
              )}
            </div>
          )}
        </div>
      ) : null}
    </>
  );
}

PropertySliderContent.propTypes = {};

export default PropertySliderContent;
